<style>
#prwRegisterModal .v--modal-box.v--modal {
  min-height: 440px !important;
  min-width: 620px !important;
}
#prwRegisterModal .modal__footer {
  display: none;
}
</style>

<template>
  <Modal
    modalName="prwRegisterModal"
    title="REJESTR PUNKTÓW ROZBIORU WODY"
    :buttons="[]"
    :register="register"
  >
    <PrwTable />
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import PrwTable from "../../table/PrwTable";

export default {
  components: {
    Modal,
    PrwTable
  },
  data: () => ({
    register: true
  })
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/watermeters/modals/PrwRegister.vue